import { lazy } from "react";
import { ProtectedRoute } from "../components/ProtectedRoute";
import PasswordContextProvider from "../contexts/PasswordContext";

const voucheringRouteConfig = [
  {
    parent: {
      exact: true,
      path: "/voucher/vouchering",
      element: ProtectedRoute,
      permission_id: 12,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/vouchering/DocumentVouchering")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/voucher/returned-vouchers",
      element: ProtectedRoute,
      permission_id: 12,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/vouchering/returned/ReturnedDocument")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/voucher/filing",
      element: ProtectedRoute,
      permission_id: 11,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/filing/DocumentFiling")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/voucher/managers_cheque/filing",
      element: ProtectedRoute,
      permission_id: 30,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() =>
        import("../routes/filing/managers-cheque/DocumentManagersChequeFiling.jsx")
      ),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/voucher/reversing",
      element: ProtectedRoute,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/reversing/DocumentReversing")),
      wrapper: PasswordContextProvider,
    },
  },
];

export default voucheringRouteConfig;
